import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";


const SideMenu = ({ data,getOpen,setIsopen }) => {
  const [isOpen, setOpen] = useState(false);
  const [subMenu, setSubMenu] = useState("");
  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
  const timeOut = useRef(null);

  const toggle = (e) => {
    e.preventDefault();
    setOpen(!isOpen);
    //setOutOpen(isOpen);
    setIsopen(false);
    console.log('toggle:'+isOpen);
  };

  const categories = [
    {
      id: "1",
      name: "Mobile, Tablets & Accessories",
      hasSubMenu: false,
      subItems: [
        {
          id: "",
          name: "",
          hasSubMenu: false,
          subItems: [{ id: "", name: "" }],
        },
      ],
    },
    {
      id: "2",
      name: "Computers & Office Supplies",
      hasSubMenu: true,
      subItems: [
        {
          id: "2.1",
          name: "category 1",
          hasSubMenu: false,
          subItems: [{ id: "", name: "" }],
        },
        {
          id: "2.2",
          name: "category 2",
          hasSubMenu: false,
          subItems: [{ id: "", name: "" }],
        },
        {
          id: "2.3",
          name: "category 3",
          hasSubMenu: false,
          subItems: [{ id: "", name: "" }],
        },
      ],
    },
    {
      id: "3",
      name: "Electronics",
      hasSubMenu: true,
      subItems: [
        {
          id: "3.1",
          name: " Home Audio & Video",
          hasSubMenu: true,
          subItems: [
            { id: "3.1.1", name: "Camera & Photo", hasSubMenu: false },
            { id: "3.1.2", name: "Home Audio", hasSubMenu: false },
            { id: "3.1.3", name: "Tv & Video", hasSubMenu: false },
            { id: "3.1.4", name: "Computers & Accessories", hasSubMenu: false },
            {
              id: "3.1.5",
              name: "Car & Vehicle Electronics",
              hasSubMenu: false,
            },
            { id: "3.1.6", name: "Portable Audio & Video", hasSubMenu: false },
          ],
        },
        {
          id: "3.2",
          name: "Mobile Phones",
          hasSubMenu: false,
          subItems: [{ id: "", name: "" }],
        },
        {
          id: "3.3",
          name: "Cameras",
          hasSubMenu: false,
          subItems: [{ id: "", name: "" }],
        },
      ],
    },
  ];

  const prevMenuRef = useRef();
  useEffect(() => {
    prevMenuRef.current = subMenu;
  });
  useEffect(() => {
    setOpen(getOpen);
    console.log('Side menu:'+getOpen);
  
}, [getOpen]);
  const prevSubMenu = prevMenuRef.current;
  const scrollToSection = () => {
    scroller.scrollTo(".submenu", {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };
  const findParent = (childId, level) => {

    if (level === "main") {
      setSubMenu("");
    } else {

      setSubMenu(prevSubMenu);
    }
  };
  const myGreeting = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })

  }
  const handleSearchChange = (id) => {
    clearTimeout(timeOut.current);
    timeOut.current = setTimeout(() => {
      document.getElementById(id).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      // setSearchKey(e.target.value.toLowerCase().trim());
    }, 200);
  }
  const renderCates = (cat, level) => {
    if (cat.hasSubMenu) {
      return (
        <li className='has-submenu' key={cat.id}>
          {/* <Link to='#' className='disabled-link' data-submenu={cat.id} onClick={() => setSubMenu(cat.id)}>
            {cat.title}
          </Link> */}
          <a href="javascript:void(0)" rel="nofollow" data-submenu={cat.id} onClick={() => {
            // var myDiv = document.getElementById('#18');
            // myDiv.scrollTop = 0;
            //   var myDiv = document.getElementById("jaban18");
            //  // alert(myDiv.offsetTop);
            //   window.scroll({
            //     top: 20,
            //     left: 0,
            //     behavior: 'smooth'
            //   });
            // scrollToSection();

            setSubMenu(cat.id)
            // document.getElementById(cat.id).scrollTop(20);
            // document.getElementById(cat.id).scrollTop += 100;
            //  setTimeout(myGreeting(cat.id), 7000);
            handleSearchChange(cat.id);
          }
          }
          >
            {cat.title}
          </a>

          <div
            id={cat.id}
            className={
              subMenu === cat.id ? "submenu opened current jaban-" + subMenu + "--" + cat.id : "submenu jaban" + cat.id
            }
          >
            <div className='submenu-header'>
              {/* <Link
                to='#' className='disabled-link'
                data-submenu-close={cat.id}
                onClick={() => findParent(cat.id, level)}
              >
                {level === "main" ? "Main Menu" : "Categories"}
              </Link> */}
              <a href="javascript:void(0)" rel="nofollow" className='disabled-link'
                data-submenu-close={cat.id}
                onClick={() => findParent(cat.id, level)}>
                {level === "main" ? "Main Menu" : "Categories"}
              </a>
            </div>
            <label>
              <a href={`/category/${cat.slug}`} title={cat.title}>
                {cat.title}
              </a></label>
            <ul>
              {cat.subItems &&
                cat.subItems.map((sub) => renderCates(sub, "sub"))}
            </ul>
          </div>
        </li>
      );
    }

    return (
      <li key={cat.id}>
        <a href={`/category/${cat.slug}`} title={cat.title}>
          {cat.title}
        </a>
      </li>
    );
  };

  return (
    <>

    
    {/* <div className="col-auto "> */}
      <div className={isOpen ? "ui dropdown zeynep-opened" : "ui dropdown  "}>
        <a
          href='/'
          onClick={toggle}
          className='category_drop web-blk'
          title='Categories'
        >
          <i className='uil uil-apps'></i>
          <span className='cate__icon'>Select Category</span>
        </a>
        {/* <div className='catey__icon'>
          <a
            onClick={toggle}
            href='/'
            className='cate__btn category_drop '
            title='Categories'
          >
            <i className='uil uil-apps'></i> Category
          </a>
        </div> */}
         

        <div id="menuCon" className={isOpen ? "zeynep opened" : "zeynep"}>
          <div className='bx-blk'>
            <span>
              <i className='uil uil-user-circle'></i> Welcome
            </span>
          </div>

          <ul>{data.data && data.data.map((cat) => renderCates(cat, "main"))}</ul>
        </div>
        <div onClick={toggle} className='zeynep-overlay'></div>
      </div>
    {/* </div> */}
    </>
  );
};

export default SideMenu;
